"use strict";
/*

This hook contains little helpers that other wise would live
on the VideoPlayer, PreviewPlayer or controllers.

Keep compability bewtween player kinds.

*/
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlayerTools = function (_a) {
    var videoRef = _a.videoRef, setCanPlayVideo = _a.setCanPlayVideo, playingSecondVideo = _a.playingSecondVideo, hasCustomIntro = _a.hasCustomIntro, changeToSecondVideo = _a.changeToSecondVideo, changeToFirstVideo = _a.changeToFirstVideo, controller = _a.controller, campaignMeta = _a.campaignMeta;
    var _b = react_1.useState(100), volumeLevel = _b[0], setVolumeLevel = _b[1];
    var handleVideoOnVolumeChange = function () {
        var _a, _b;
        if ((_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.volume) {
            var volume = ((_b = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _b === void 0 ? void 0 : _b.volume) * 100;
            setVolumeLevel(volume);
        }
    };
    var onCanPlayHandler = function () {
        var _a;
        setCanPlayVideo(true);
        // here use fix
        if (inTransition) {
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        }
        var id = setTimeout(function () {
            setInTransition(false);
            clearTimeout(id);
        }, 500);
    };
    var _c = react_1.useState(false), inTransition = _c[0], setInTransition = _c[1];
    var playNextVideo = function () {
        if (videoRef.current && hasCustomIntro && !playingSecondVideo) {
            setInTransition(true);
            changeToSecondVideo();
        }
    };
    var aspectRatioConstrainer = function (aspectRatio) {
        if (aspectRatio === void 0) { aspectRatio = "5:4"; }
        var _a = aspectRatio.split(":"), width = _a[0], height = _a[1];
        return parseInt(width) > parseInt(height) ? "width" : "height";
    };
    var handleRewind = function () {
        var video = videoRef.current;
        var REWIND_SECONDS = 5;
        var TRANSITION_DELAY_MS = 100;
        if (video) {
            var videoCurrentTime_1 = video.currentTime;
            if (videoCurrentTime_1 > REWIND_SECONDS) {
                video.currentTime -= REWIND_SECONDS;
            }
            else if (playingSecondVideo) {
                setInTransition(true);
                changeToFirstVideo();
                setTimeout(function () {
                    var _a;
                    video.play();
                    video.currentTime = (((_a = campaignMeta === null || campaignMeta === void 0 ? void 0 : campaignMeta.video) === null || _a === void 0 ? void 0 : _a.duration) || 0) - (REWIND_SECONDS - videoCurrentTime_1);
                }, TRANSITION_DELAY_MS);
            }
            else {
                video.currentTime = 0;
            }
            controller === null || controller === void 0 ? void 0 : controller.handleRewind();
        }
    };
    var handleFoward = function () {
        var video = videoRef.current;
        if (video) {
            if (Number.isNaN(video.duration)) {
                return 0;
            }
            if (video.currentTime < video.duration - 5) {
                video.currentTime += 5;
            }
            else if (hasCustomIntro && !playingSecondVideo) {
                setInTransition(true);
                changeToSecondVideo();
            }
            else {
                video.currentTime = video.duration;
            }
        }
        controller === null || controller === void 0 ? void 0 : controller.handleFoward();
    };
    var handlePlayVideoClick = function () {
        var video = videoRef.current;
        // hack weird error on property not found
        var controllerx = controller;
        if (video) {
            if (!(video === null || video === void 0 ? void 0 : video.currentTime) && !!(controllerx === null || controllerx === void 0 ? void 0 : controllerx.onPlaybackTrackEvent)) {
                // eslint-disable-next-line no-void
                controllerx === null || controllerx === void 0 ? void 0 : controllerx.onPlaybackTrackEvent();
            }
            // After playing the second video, reproduce the first video
            if ((video === null || video === void 0 ? void 0 : video.ended) && playingSecondVideo) {
                changeToFirstVideo();
                return;
            }
            if (video === null || video === void 0 ? void 0 : video.paused) {
                controllerx.handleUnmuteVideo();
                video.play();
            }
            else {
                video === null || video === void 0 ? void 0 : video.pause();
            }
        }
    };
    var getProgress = function () {
        var video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (video) {
            if (Number.isNaN(video.duration)) {
                return 0;
            }
            // Other solution, check video duration, if missing use currentTime + 1 or similar
            if (video.duration === Infinity) {
                return (video.currentTime / (video.currentTime + 2)) * 100;
            }
            return (video.currentTime / video.duration) * 100;
        }
        else {
            return 0;
        }
    };
    return {
        onCanPlayHandler: onCanPlayHandler,
        handleVideoOnVolumeChange: handleVideoOnVolumeChange,
        volumeLevel: volumeLevel,
        playNextVideo: playNextVideo,
        inTransition: inTransition,
        setInTransition: setInTransition,
        aspectRatioConstrainer: aspectRatioConstrainer,
        handleRewind: handleRewind,
        handleFoward: handleFoward,
        handlePlayVideoClick: handlePlayVideoClick,
        getProgress: getProgress,
    };
};
exports.default = usePlayerTools;
